import PropTypes from 'prop-types';
import { TOOLTIP_PROP_TYPES } from '../tooltip/types';

export const CHECKBOX_PROPS = {
  name: PropTypes.string,
  checked: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  description: PropTypes.node,
  disabled: PropTypes.bool,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  tooltipProps: PropTypes.shape(TOOLTIP_PROP_TYPES),
  isLabelBold: PropTypes.bool,
};
